import { useState } from "react";
import { Reveal } from "./motion";
import { Presentation, Globe, Maximize2 } from "lucide-react";
import { IMAGES } from "@/data";
import { Dialog, DialogContent } from "@/components/ui/dialog";

export const Poster = () => {
  const [zoom, setZoom] = useState(false);
  return (
    <section className="py-24 sm:py-32 bg-[#1A1C1A] scroll-mt-24" data-testid="poster">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5">
          <Reveal>
            <p className="overline text-[#E8A87C] mb-5">On the World Stage</p>
            <h2 className="font-serif-display font-light text-4xl sm:text-5xl text-[#FDFBF7] tracking-tight">
              International <span className="italic text-[#E8A87C]">ESGO</span> presentation
            </h2>
            <p className="mt-6 text-[#c9c7c1] leading-relaxed">
              Dr. Pranidha presented her research — <span className="text-[#FDFBF7]">“Mapping Lymphedema:
              A Prospective Study of Its Burden, Predictors and Quality-of-Life Impact after Nodal Staging
              in Endometrial Cancer”</span> — as an International Poster Presenter at the 27th ESGO Congress,
              ESGO 2026, Copenhagen, and as an oral &amp; poster presenter at AGOICON.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm text-[#FDFBF7]">
                <Globe size={15} className="text-[#E8A87C]" /> ESGO 2026 · Copenhagen
              </span>
              <span className="inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm text-[#FDFBF7]">
                <Presentation size={15} className="text-[#E8A87C]" /> Poster P10-03
              </span>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <button
              onClick={() => setZoom(true)}
              className="group relative w-full rounded-3xl overflow-hidden border border-white/10 shadow-2xl shadow-black/40"
              data-testid="poster-image"
            >
              <img
                src={IMAGES.esgoPoster}
                alt="Dr. Pranidha Shree presenting her research poster at the 27th ESGO Congress 2026, Copenhagen"
                className="w-full max-h-[560px] object-cover object-top group-hover:scale-[1.02] transition-transform duration-700"
              />
              <span className="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/50 backdrop-blur-sm text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Maximize2 size={16} />
              </span>
              <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent px-5 py-4 text-left">
                <span className="text-[#FDFBF7] text-sm">27th ESGO Congress · Copenhagen, Denmark · Feb 2026</span>
              </span>
            </button>
          </Reveal>
        </div>
      </div>

      <Dialog open={zoom} onOpenChange={setZoom}>
        <DialogContent className="max-w-3xl bg-[#1A1C1A] p-2 border-white/10" data-testid="poster-zoom">
          <img src={IMAGES.esgoPoster} alt="ESGO Congress poster" className="w-full rounded-xl max-h-[85vh] object-contain" />
        </DialogContent>
      </Dialog>
    </section>
  );
};
